module.exports = __webpack_public_path__ + "static/media/AJ1.a1ef17af.jpg";